import { beamBetween } from '../geometry/panels';
import { Chassis } from '../../scene/Chassis';
import { useBodyPalette } from '../../scene/BodyFinish';
import { GLASS, HEADLIGHT } from '../../scene/materials';

const WheelLoaderBody = () => {
  const palette = useBodyPalette('wheel_loader');
  const arm = beamBetween([0.9, 1.25], [2.45, 0.68], { thickness: 0.18, depth: 0.16 });
  const ram = beamBetween([0.92, 1.02], [2.05, 0.82], { thickness: 0.09, depth: 0.08 });

  return <group>
    <Chassis>
      <mesh position={[-0.05, 0.86, 0]}>
        <boxGeometry args={[4.9, 0.48, 1.28]} />
        <meshPhysicalMaterial {...palette.chassis} />
      </mesh>
      <mesh position={[2.05, 0.66, 0]}>
        <boxGeometry args={[0.48, 0.24, 1.72]} />
        <meshPhysicalMaterial {...palette.chassis} />
      </mesh>
      <mesh position={[-2.05, 0.7, 0]}>
        <boxGeometry args={[0.55, 0.28, 1.78]} />
        <meshPhysicalMaterial {...palette.chassis} />
      </mesh>
    </Chassis>

    <mesh position={[1.3, 1.2, 0]}>
      <boxGeometry args={[1.35, 0.66, 1.2]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>
    <mesh position={[-0.35, 1.28, 0]}>
      <boxGeometry args={[1.9, 0.42, 1.34]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>
    <mesh position={[-0.55, 2.0, 0]}>
      <boxGeometry args={[1.7, 1.15, 1.3]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>
    <mesh position={[-0.55, 2.08, 0]}>
      <boxGeometry args={[1.42, 0.78, 1.12]} />
      <meshPhysicalMaterial {...GLASS} />
    </mesh>
    <mesh position={[-0.55, 2.63, 0]}>
      <boxGeometry args={[1.82, 0.13, 1.4]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>

    {[-1, 1].map((side) => <group key={`loader-arm-${side}`}>
      <mesh position={[arm.position[0], arm.position[1], side * 0.62]} rotation={arm.rotation}>
        <boxGeometry args={arm.args} />
        <meshPhysicalMaterial {...palette.body} />
      </mesh>
      <mesh position={[ram.position[0], ram.position[1], side * 0.62]} rotation={ram.rotation}>
        <boxGeometry args={ram.args} />
        <meshPhysicalMaterial {...palette.edge} />
      </mesh>
    </group>)}
    <mesh position={[2.48, 0.62, 0]}>
      <boxGeometry args={[0.16, 0.7, 1.95]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>
    <mesh position={[2.78, 0.28, 0]} rotation={[0, 0, -0.12]}>
      <boxGeometry args={[0.72, 0.14, 2.05]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`bucket-side-${side}`} position={[2.62, 0.48, side * 0.98]}>
      <boxGeometry args={[0.66, 0.5, 0.08]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>)}
    <mesh position={[2.64, 1.34, 0]}>
      <boxGeometry args={[0.08, 0.22, 0.7]} />
      <meshPhysicalMaterial {...palette.edge} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`headlight-${side}`} position={[1.98, 1.38, side * 0.43]}>
      <boxGeometry args={[0.08, 0.17, 0.24]} />
      <meshPhysicalMaterial {...HEADLIGHT} />
    </mesh>)}
  </group>;
};

export { WheelLoaderBody };
